import React from "react";
import { Redirect, Route } from "react-router-dom";

import Nav from "../nav";
import Delivery from "./delivery";
import Tables from "./tables";
import Tickets from "./tickets";
import Account from "./account";
import Sales from "./sales";
import Rappi from "./rappi";
import { has_access } from "../../../../middleware/privileges";

const Pref: React.FC = () => {
  const canEditInfo = has_access(128); // edit_info

  const main_nav = [
    ...(canEditInfo
      ? [
          { name: { es: "Cuenta", en: "Overview" }, link: "/settings/account" },
          {
            name: { es: "Envíos a Domicilio", en: "Delivery" },
            link: "/settings/delivery",
          },
          {
            name: { es: "Mesas", en: "Tables" },
            link: "/settings/tables",
          },
        ]
      : []),
    {
      name: { es: "Tickets", en: "Tickets" },
      link: "/settings/tickets",
    },
    ...(canEditInfo
      ? [
          {
            name: { es: "Ventas", en: "Sales" },
            link: "/settings/sales",
          },
        ]
      : []),
    // {
    //   name: { es: "Rappi", en: "Rappi" },
    //   link: "/settings/rappi",
    // },
  ];

  return (
    <div className="pref_section">
      <Nav items={main_nav} />
      <Route path="/account/settings" exact={true}>
        <Redirect
          to={
            canEditInfo
              ? "/account/settings/account"
              : "/account/settings/tickets"
          }
        />
      </Route>
      <Route path="/account/settings/tickets" component={Tickets} />
      {canEditInfo && (
        <>
          <Route path="/account/settings/delivery" component={Delivery} />
          <Route path="/account/settings/tables" component={Tables} />
          <Route path="/account/settings/account" component={Account} />
          <Route path="/account/settings/sales" component={Sales} />
          <Route path="/account/settings/rappi" component={Rappi} />
        </>
      )}
    </div>
  );
};

export default Pref;
